import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { InformativeMessagesFailure, InformativeMessagesRequest, InformativeMessagesSuccess } from './actions';
import { InformativeMessage } from '@models/swagger';

export const featureKey = 'informativeMessages';

export interface State {
  data: InformativeMessage[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(InformativeMessagesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(InformativeMessagesRequest, state => ({ ...state, error: null, loading: true })),
    on(InformativeMessagesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
